import { Avatar } from '@atom/mui';
import { MapUser } from '@atom/types/map';

import classes from './list.module.css';

const styles = {
  avatar: {
    width: '2.125rem',
    height: '2.125rem',
  },
};

type UserListItemProps = {
  user: MapUser;
  onSelect: (id: string) => void;
  onHover?: (id: string | null) => void;
};

const UserListItem = ({ user, onSelect, onHover }: UserListItemProps) => {
  const { id, photoUrl, firstName, lastName, role, email } = user;

  return (
    <div
      className={classes.listItem}
      onClick={() => onSelect(id)}
      onMouseEnter={() => onHover?.(id)}
      onMouseLeave={() => onHover?.(null)}
    >
      <div className={classes.itemIcon}>
        <Avatar
          src={photoUrl}
          alt={`${firstName} ${lastName}`}
          style={styles.avatar}
        />
      </div>
      <div className={classes.itemBody}>
        <div className={classes.itemHeading}>
          {firstName} {lastName}
        </div>
        <div className={classes.itemSecondary}>{email}</div>
        <div className={classes.itemSecondary}>{role}</div>
      </div>
    </div>
  );
};

export default UserListItem;
